"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLayerImages = exports.getDepotSource = void 0;
/* eslint-disable */
var react_1 = __importDefault(require("react"));
var types_1 = require("../types");
var mapbox_gl_1 = __importDefault(require("mapbox-gl"));
var wasteDepot_1 = __importDefault(require("../tooltips/wasteDepot"));
var react_dom_1 = __importDefault(require("react-dom"));
var common_1 = require("./common");
var icons_1 = require("../../../icons");
var getDepotSource = function (_a) {
    var points = _a.points, onClick = _a.onClick;
    var depots = points;
    var depotId;
    var images = exports.getLayerImages();
    var depotImage = images[0].image;
    var wasteImage = images[1].image;
    return {
        layers: [
            {
                data: {
                    id: "depots-unclustered-point",
                    type: "symbol",
                    source: "depots",
                    layout: {
                        "icon-allow-overlap": true,
                        "text-allow-overlap": true,
                        "icon-image": [
                            "match",
                            ["get", "id"],
                            0,
                            ["get", "image-icon-hover"],
                            ["get", "image-icon"],
                        ],
                        "text-field": ["get", "stop-number"],
                        "icon-size": 1,
                        "icon-offset": [0, 10],
                        "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
                        // "text-font": ["SF Pro Text Regular", "DIN Offc Pro Medium", "Arial Unicode MS Bold"],
                        "text-size": 13,
                        "text-offset": ["get", "text-offset"],
                    },
                    filter: ["!", ["has", "point_count"]],
                    paint: {
                        "text-color": ["get", "text-color"],
                    },
                },
                onClick: function (e, map) {
                    var _a, _b, _c, _d, _e;
                    // @ts-ignore
                    var features = map.queryRenderedFeatures(e.point, {
                        layers: ["depots-unclustered-point"],
                    });
                    // @ts-ignore
                    var center = (_b = (_a = features[0]) === null || _a === void 0 ? void 0 : _a.geometry) === null || _b === void 0 ? void 0 : _b.coordinates;
                    map.easeTo({
                        center: center,
                    });
                    if (onClick) {
                        onClick((_d = (_c = features[0]) === null || _c === void 0 ? void 0 : _c.properties) === null || _d === void 0 ? void 0 : _d.id);
                    }
                    var toolTipData = features[0];
                    var depotData = {};
                    if ((toolTipData === null || toolTipData === void 0 ? void 0 : toolTipData.properties) && ((_e = toolTipData.properties) === null || _e === void 0 ? void 0 : _e.location)) {
                        toolTipData.properties.location = JSON.parse(toolTipData.properties.location);
                        depotData = toolTipData.properties;
                    }
                    if (map.getZoom() >= 9) {
                        // showing the pop-up on the map
                        var placeholder = document.createElement("div");
                        var Content = (react_1.default.createElement(wasteDepot_1.default, { depotImage: depotImage, wasteImage: wasteImage, type: depotData["depot-type"], location: depotData.location }));
                        react_dom_1.default.render(Content, placeholder);
                        new mapbox_gl_1.default.Popup({
                            maxWidth: "240px",
                        })
                            // @ts-ignore
                            .setLngLat(features[0].geometry.coordinates)
                            .setDOMContent(placeholder)
                            .addTo(map);
                    }
                },
                // onMouseEnter: (e: unknown, map: mapboxgl.Map) => {
                //   // @ts-ignore
                //   if (e.features.length > 0) {
                //     if (depotId) {
                //       map.removeFeatureState({
                //         source: "depots",
                //         // @ts-ignore
                //         id: depotId,
                //       });
                //     }
                //
                //     // @ts-ignore
                //     depotId = e.features[0].id;
                //     // @ts-ignore
                //     // @ts-ignore
                //     map.setLayoutProperty("depots-unclustered-point", "icon-image", [
                //       "match",
                //       ["get", "id"],
                //       // @ts-ignore
                //       e.features[0].properties.id,
                //       ["get", "image-icon-hover"],
                //       ["get", "image-icon"],
                //     ]);
                //
                //     map.setFeatureState(
                //       {
                //         source: "depots",
                //         // @ts-ignore
                //         id: depotId,
                //       },
                //       {
                //         hover: true,
                //       }
                //     );
                //   }
                //   map.getCanvas().style.cursor = "pointer";
                // },
                // onMouseLeave: (e: unknown, map: mapboxgl.Map) => {
                //   if (depotId || depotId === 0) {
                //     // @ts-ignore
                //     map.setLayoutProperty("depots-unclustered-point", "icon-image", [
                //       "match",
                //       ["get", "id"],
                //       0,
                //       ["get", "image-icon-hover"],
                //       ["get", "image-icon"],
                //     ]);
                //     map.setFeatureState(
                //       {
                //         source: "depots",
                //         // @ts-ignore
                //         id: depotId,
                //       },
                //       {
                //         hover: false,
                //       }
                //     );
                //   }
                //
                //   depotId = null;
                //   map.getCanvas().style.cursor = "";
                // },
                // onMouseMove: (e: unknown, map: mapboxgl.Map) => {
                //   // @ts-ignore
                //   if (e.features.length > 0) {
                //     if (depotId) {
                //       map.removeFeatureState({
                //         source: "depots",
                //         // @ts-ignore
                //         id: depotId,
                //       });
                //     }
                //
                //     // @ts-ignore
                //     depotId = e.features[0].id;
                //     // @ts-ignore
                //     // @ts-ignore
                //     map.setLayoutProperty("depots-unclustered-point", "icon-image", [
                //       "match",
                //       ["get", "id"],
                //       // @ts-ignore
                //       e.features[0].properties.id,
                //       ["get", "image-icon-hover"],
                //       ["get", "image-icon"],
                //     ]);
                //
                //     map.setFeatureState(
                //       {
                //         source: "depots",
                //         // @ts-ignore
                //         id: depotId,
                //       },
                //       {
                //         hover: true,
                //       }
                //     );
                //   }
                //   map.getCanvas().style.cursor = "pointer";
                // },
            },
        ],
        sourceId: "depots",
        source: {
            generateId: true,
            type: "geojson",
            data: {
                type: "FeatureCollection",
                features: depots.map(function (depot) {
                    var imgSrc = "";
                    var textColor = "#FFFFFF";
                    var borderColor = "#FFFFFF";
                    var backgroundColor = "#000000";
                    var textOffset = [1.25, 0.2];
                    switch (depot.type) {
                        case types_1.EDepotType.CURRENT_DEPOT_STOP:
                            imgSrc = "depot-station";
                            backgroundColor = "#FFFFFF";
                            textColor = "#1890FF";
                            borderColor = "#1890FF";
                            textOffset = [2.2, 0.45];
                            break;
                        case types_1.EDepotType.CURRENT_WASTE_STOP:
                            imgSrc = "waste-station";
                            backgroundColor = "#FFFFFF";
                            textColor = "#1890FF";
                            borderColor = "#1890FF";
                            textOffset = [2.2, 0.45];
                            break;
                        case types_1.EDepotType.COMPLETE_WASTE_STATION:
                            imgSrc = "completed-waste-station";
                            textColor = "#FFFFFF";
                            backgroundColor = "#7CC81B";
                            borderColor = "#7CC81B";
                            textOffset = [1.6, 0.45];
                            break;
                        case types_1.EDepotType.COMPLETE_DEPOT:
                            imgSrc = "completed-depot-station";
                            textColor = "#FFFFFF";
                            backgroundColor = "#7CC81B";
                            borderColor = "#7CC81B";
                            textOffset = [1.5, 0.45];
                            break;
                        case types_1.EDepotType.PENDING_WASTE_STATION:
                            imgSrc = "pending-waste-station";
                            textColor = "#909DA9";
                            backgroundColor = "#FFFFFF";
                            borderColor = "#909DA9";
                            textOffset = [1.6, 0.45];
                            break;
                        case types_1.EDepotType.PENDING_DEPOT:
                            imgSrc = "pending-depot-station";
                            textColor = "#909DA9";
                            backgroundColor = "#FFFFFF";
                            borderColor = "#909DA9";
                            textOffset = [1.5, 0.45];
                            break;
                        case types_1.EDepotType.DEPOT_STATION:
                            imgSrc = "depot-station";
                            textColor = "#FFFFFF";
                            backgroundColor = "#1890FF";
                            borderColor = "#1890FF";
                            break;
                        case types_1.EDepotType.WASTE_STATION:
                            imgSrc = "waste-station";
                            textColor = "#FFFFFF";
                            backgroundColor = "#1890FF";
                            borderColor = "#1890FF";
                            break;
                        default:
                            break;
                    }
                    return {
                        type: "Feature",
                        properties: {
                            id: depot.id,
                            "image-icon": imgSrc,
                            "image-icon-hover": imgSrc + "-hover",
                            location: depot.location,
                            type: depot.type,
                            "depot-type": depot.depotType,
                            "text-color": textColor,
                            "background-color": backgroundColor,
                            "border-color": borderColor,
                            "text-offset": textOffset,
                        },
                        geometry: {
                            type: "Point",
                            coordinates: [depot.location.longitude, depot.location.latitude],
                        },
                    };
                }),
            },
        },
        images: images,
    };
};
exports.getDepotSource = getDepotSource;
var getLayerImages = function () {
    return [
        {
            name: "depot-station",
            image: common_1.getSvgImage(function () { return react_1.default.createElement(icons_1.DepotMarker, { color: "#0090FF", size: common_1.IMAGE_SIZE }); }, 15 * common_1.IMAGE_SCALE, 15 * common_1.IMAGE_SCALE),
            external: false,
        },
        {
            name: "depot-station-hover",
            image: common_1.getSvgImage(function () { return react_1.default.createElement(icons_1.DepotMarker, { color: "#1578d4", size: common_1.IMAGE_SIZE }); }, 15 * common_1.IMAGE_SCALE, 15 * common_1.IMAGE_SCALE),
            external: false,
        },
        {
            name: "current-depot-station",
            image: common_1.getSvgImage(function () { return react_1.default.createElement(icons_1.DepotMarker, { color: "#1890ff", size: common_1.IMAGE_SIZE }); }, 15 * common_1.IMAGE_SCALE, 15 * common_1.IMAGE_SCALE),
            external: false,
        },
        {
            name: "completed-depot-station",
            image: common_1.getSvgImage(function () { return react_1.default.createElement(icons_1.DepotMarker, { color: "#7CC81B", size: common_1.IMAGE_SIZE }); }, 15 * common_1.IMAGE_SCALE, 15 * common_1.IMAGE_SCALE),
            external: false,
        },
        {
            name: "completed-waste-station",
            image: common_1.getSvgImage(function () { return react_1.default.createElement(icons_1.WasteStationMarker, { color: "#7CC81B", size: common_1.IMAGE_SIZE }); }, 15 * common_1.IMAGE_SCALE, 15 * common_1.IMAGE_SCALE),
            external: false,
        },
        {
            name: "pending-depot-station",
            image: common_1.getSvgImage(function () { return react_1.default.createElement(icons_1.DepotMarker, { color: "#909DA9", size: common_1.IMAGE_SIZE }); }, 15 * common_1.IMAGE_SCALE, 15 * common_1.IMAGE_SCALE),
            external: false,
        },
        {
            name: "pending-waste-station",
            image: common_1.getSvgImage(function () { return react_1.default.createElement(icons_1.WasteStationMarker, { color: "#909DA9", size: common_1.IMAGE_SIZE }); }, 15 * common_1.IMAGE_SCALE, 15 * common_1.IMAGE_SCALE),
            external: false,
        },
        {
            name: "waste-station",
            image: common_1.getSvgImage(function () { return react_1.default.createElement(icons_1.WasteStationMarker, { color: "#0090FF", size: common_1.IMAGE_SIZE }); }, 15 * common_1.IMAGE_SCALE, 15 * common_1.IMAGE_SCALE),
            external: false,
        },
        {
            name: "waste-station-hover",
            image: common_1.getSvgImage(function () { return react_1.default.createElement(icons_1.WasteStationMarker, { color: "#1578d4", size: common_1.IMAGE_SIZE }); }, 15 * common_1.IMAGE_SCALE, 15 * common_1.IMAGE_SCALE),
            external: false,
        },
    ];
};
exports.getLayerImages = getLayerImages;
